import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  InvestigationItem,
  actOnInvestigation,
} from '../../../api/investigationsAdminService';
import FilterButton from '../../../components/Admin/Investigations/FilterButton';

interface Props {
  investigation: InvestigationItem | null;
  refresh: () => void;
}

const InvestigationDetail: React.FC<Props> = ({ investigation, refresh }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');

  if (!investigation) {
    return (
      <div className="flex items-center justify-center h-[72vh] text-gray-400 rounded-xl border border-dashed">
        {t('admin.select_investigation')}
      </div>
    );
  }

  const handleDecision = async (action: 'accept' | 'reject') => {
    await actOnInvestigation(investigation.id, action, comment);
    setComment('');
    refresh();
  };

  const infoBlock = (title: string, body: React.ReactNode) => (
    <section className="space-y-1">
      <h3 className="font-semibold text-sm text-gray-700">{title}</h3>
      <div className="text-sm text-gray-800 break-words">{body}</div>
    </section>
  );

  return (
    <div className="h-[72vh] overflow-y-auto rounded-xl shadow ring-1 ring-gray-200 bg-white p-6 flex flex-col gap-6">
      <h2 className="text-lg font-bold text-slate-800">{investigation.company_name}</h2>

      {infoBlock(t('admin.comments'), investigation.comments || '—')}
      {infoBlock(t('admin.domains'), investigation.domains.length ? investigation.domains.join(', ') : '—')}
      {infoBlock(t('admin.urls'), investigation.urls.length ? investigation.urls.join(', ') : '—')}

      {infoBlock(
        t('admin.user'),
        investigation.user ? (
          <>
            <p>{investigation.user.email}</p>
            <p className="text-xs text-gray-500">
              {investigation.user.first_name} {investigation.user.last_name}
            </p>
            <p className="text-xs text-gray-500">
              {t('admin.tokens')}: {investigation.user.sienaguard_tokens_balance}
            </p>
            <p className="text-xs text-gray-500">
              {t('admin.created_at')}: {investigation.user.created_at}
            </p>
            
          </>
        ) : (
          '—'
        )
      )}

      {investigation.status === 'under_review' && (
        <>
          <textarea
            className="w-full border rounded p-2 text-sm"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t('admin.admin_comment')}
          />
          <div className="flex gap-2">
            <FilterButton onClick={() => handleDecision('accept')}>
              {t('admin.accept')}
            </FilterButton>
            <FilterButton onClick={() => handleDecision('reject')}>
              {t('admin.reject')}
            </FilterButton>
          </div>
        </>
      )}
    </div>
  );
};

export default InvestigationDetail;
